import styled from "styled-components/macro";
import { borderRadius, selected } from "theme";

export const GridContainer = styled("div")`
  ${({
    theme: {
      colors: { textSecondary, white },
    },
  }) => `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(54px, 1fr));
  overflow: hidden;
  color: ${textSecondary};
  `}
  ${borderRadius}
`;

const HeightMaker = styled("div")`
  cursor: pointer;
  width: 100%;
  height: 44px;
  &:after {
    content: "";
    display: block;
    margin-top: 50%;
  }
`;

const CenteringDiv = styled("div")`
  ${({
    theme: {
      colors: { fnGrey, offWhite },
    },
  }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 28px;
  border: 0.5px solid ${fnGrey};
  &:hover {background-color: ${offWhite};}
  `}
  ${selected}
`;

export const IconContainer = ({ children, $selected, ...rest }) => (
  <HeightMaker {...rest}>
    <CenteringDiv $selected={$selected}>{children}</CenteringDiv>
  </HeightMaker>
);

const fnrIconGridContainers = { GridContainer, IconContainer };
export default fnrIconGridContainers;
